exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OwnersHeader___3Yv3d {\n  font-family: var(--font-family-sans);\n}\n\n.InspectedElement___AIaEa {\n  overflow-x: hidden;\n  overflow-y: auto;\n  font-family: var(--font-family-monospace);\n  font-size: var(--font-size-monospace-normal);\n  line-height: var(--line-height-data);\n}\n\n.InspectedElementSection___cKzj1:not(:empty) {\n  padding: 0.25rem;\n\n  &:not(:last-of-type) {\n    border-bottom: 1px solid var(--color-border);\n  }\n}\n\n.OwnersMetaField___ot46- {\n  padding-left: 1.25rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.RenderedBySkeleton___3haqI {\n  padding-left: 1.25rem;\n}", ""]);

// exports
exports.locals = {
	"OwnersHeader": "OwnersHeader___3Yv3d",
	"InspectedElement": "InspectedElement___AIaEa",
	"InspectedElementSection": "InspectedElementSection___cKzj1",
	"OwnersMetaField": "OwnersMetaField___ot46-",
	"RenderedBySkeleton": "RenderedBySkeleton___3haqI"
};